const useAppendDomainProtocolToURL = () => (url: string) =>
  /^https?:\/\//.test(url) ? url : `https://${url}`

export default useAppendDomainProtocolToURL
